import { addDays } from 'date-fns'

import { LegacyWarningModal } from '#components'
import { COOKIE_LEGACY_WARNING } from '~/constants/cookies'

export const useLegacyWarning = () => {
  const showLegacyBrowserWarning = ref(false)

  const { registerModal } = useModal()

  watchImmediate(
    () => navigator && navigator.userAgent,
    (ua) => {
      if (import.meta.server) return
      if (!ua) return

      const isLegacy = isLegacyBrowser(ua)

      const cookie = useCookie(COOKIE_LEGACY_WARNING, {
        default: () => false,
        expires: addDays(new Date(), 7),
      })

      if (!cookie.value) {
        showLegacyBrowserWarning.value = isLegacy
      }

      cookie.value = isLegacy
    },
  )

  registerModal({
    component: LegacyWarningModal,
    onConfirm: () => {
      showLegacyBrowserWarning.value = false
    },
    // a global notice, ahead of anything a page registers (editor restore modal: 10)
    priority: 90,
    when: () => Boolean(showLegacyBrowserWarning.value),
  })

  return { showLegacyBrowserWarning }
}
